import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAllPsychicsInfoAndStatitstic } from 'actions/superuser';
import { internalLogIn } from 'actions/auth';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { Psychic } from 'elements';


import './PsychicsPage.css';
import { ADMIN_ROLES } from 'layouts/partials/header/Header';


function mapState(state) {
  return {
    ...state.superuser,
    user: state.auth.user,
    admin: state.auth.admin,
    suAccessToken: state.auth.suAccessToken
  };
}

function mapDispatch(dispatch, props) {
  return {
    getAllPsychicsInfoAndStatitstic() {
      return getAllPsychicsInfoAndStatitstic(dispatch);
    },
    internalLogIn(accessToken, suAccessToken, userInfo, adminInfo) {
      return internalLogIn(dispatch, accessToken, suAccessToken, userInfo, adminInfo);
    }
  };
}

class PsychicsPage extends Component {
  componentWillMount() {
    this.props.getAllPsychicsInfoAndStatitstic();
  }

  get displayStats() {
    return (this.props.suAccessToken && this.props.admin.role === ADMIN_ROLES.SUPERUSER);
  }

  render() {
    const adminInfo = this.props.admin;
    const psychics = this.props ? (this.props.psychics ? this.props.psychics : []) : [];
    const statistic = this.props ? (this.props.statistic ? this.props.statistic : {}) : {};
    const selectedUserUUID = this.props.user ? this.props.user.uuid : null;
    return (
      <div className="row">
        <div className="p-20 ant-col-4 statistic">
          <div className="statistic-title">Statistics</div>
          { this.displayStats &&
          <div>
            <div><span className="bold-text">Psychics: </span>{ statistic.nPsychics }</div>
            <div><span className="bold-text">Users: </span>{ statistic.nNonPsychics }</div>
            <div><span className="bold-text">Total Messages: </span>{ statistic.nMessages }</div>
            <div><span className="bold-text">Free Messages: </span>{ statistic.nFreeMessages }</div>
            <div><span className="bold-text">Paid Messages: </span>{ statistic.nPayedMessages }</div>
            <div><span className="bold-text">Total Tips: </span>{ statistic.tips || 0 }</div>
          </div>
          }
          <div><span className="bold-text">Pending Answers: </span>{ statistic.nUnanswered }</div>
          <div><span className="bold-text">Pending Paid Answers: </span>{ statistic.nUnansweredPayed }</div>
          {/*<div className="add-free-questions-a">*/ }
          {/*<NavLink className="bold-text" exact to="/users">Add Free Questions</NavLink>*/ }
          {/*</div>*/ }
          { (this.displayStats && statistic.es) &&
          <div>
            <div className="statistic-title-es">Spanish Statistics</div>
            <div>
              <div><span className="bold-text">Total Messages: </span>{ statistic.es.nMessages }</div>
              <div><span className="bold-text">Free Messages: </span>{ statistic.es.nFreeMessages }</div>
              <div><span className="bold-text">Paid Messages: </span>{ statistic.es.nPayedMessages }</div>
            </div>
          </div>
          }
        </div>

        <div className="p-20 ant-col-20">
          <div className="psychic-list-title">
            <span>Psychics</span>
            <span className="float-right">Pending / Total</span>
          </div>
          <div className="psychics-list">
            {
              _.map(psychics, (n, i) => {
                return <Psychic
                  key={ i }
                  psychic={ n }
                  clickFunction={ () => this.props.internalLogIn(n.accessToken, this.props.suAccessToken, n, adminInfo) }
                  selectedUUID={ selectedUserUUID }
                />;
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapState, mapDispatch)(PsychicsPage));



// WEBPACK FOOTER //
// ./src/pages/psychics/PsychicsPage.jsx